import { render, staticRenderFns } from "./PaymentInstoreCn.vue?vue&type=template&id=0b346969&scoped=true&"
import script from "./PaymentInstoreCn.vue?vue&type=script&lang=js&"
export * from "./PaymentInstoreCn.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInstoreCn.vue?vue&type=style&index=0&id=0b346969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346969",
  null
  
)

export default component.exports